// This icon file is generated automatically.
var PAttachmentOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.18 1.07a3.78 3.78 0 00-5.34 0L.76 5.15a.14.14 0 00-.04.1c0 .03.01.07.04.1l.58.57c.05.06.14.06.2 0L5.6 1.85a2.66 2.66 0 013.8 0 2.66 2.66 0 010 3.79L5.24 9.79l-.68.67A1.62 1.62 0 012.3 8.18L6.4 4.06c.1-.1.24-.16.4-.16a.54.54 0 01.39.94L3.8 8.2a.14.14 0 00-.04.1c0 .04.01.08.04.1l.58.58c.05.05.14.05.2 0l3.36-3.37a1.63 1.63 0 000-2.32 1.65 1.65 0 00-2.33 0l-.4.4L1.51 7.4a2.7 2.7 0 000 3.83 2.7 2.7 0 003.84 0l4.83-4.83a3.76 3.76 0 000-5.34z", "fill-rule": "nonzero" } }] }, "name": "p-attachment", "theme": "outlined" };
export default PAttachmentOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAttachmentOutlined.js
// module id = 3218
// module chunks = 0